import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Image } from '../../../AbstractElements';
import { Ratio } from '../../../Constant';
import HeaderCard from '../../Common/HeaderCard';

const Ratiocard = () => {
  return (
    <Col sm='12' xxl='6' className='box-col-12'>
      <Card>
        <HeaderCard title={Ratio} />
        <CardBody className='card-body avatar-showcase'>
          <div className='avatars'>
            <div className='avatar ratio'>
              <Image body={true} className='img-100 b-r-8' src={require('../../../assets/images/user/7.jpg')} alt='#' />
            </div>
            <div className='avatar ratio'>
              <Image body={true} className='img-90 b-r-8' src={require('../../../assets/images/user/7.jpg')} alt='#' />
            </div>
            <div className='avatar ratio'>
              <Image body={true} className='img-80 b-r-8' src={require('../../../assets/images/user/7.jpg')} alt='#' />
            </div>
            <div className='avatar ratio'>
              <Image body={true} className='img-70 b-r-8' src={require('../../../assets/images/user/7.jpg')} alt='#' />
            </div>
            <div className='avatar ratio'>
              <Image body={true} className='img-60 b-r-8' src={require('../../../assets/images/user/7.jpg')} alt='#' />
            </div>
            <div className='avatar ratio'>
              <Image body={true} className='img-50 b-r-8' src={require('../../../assets/images/user/7.jpg')} alt='#' />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Ratiocard;
